export const emptyTenantForm = {
  name: '',
  domain: '',
  subdomain: '',
  kind: 'customer',
  partnerId: '',
  appName: '',
  logoUrl: '',
  logoMarkUrl: '',
  faviconUrl: '',
  primaryColor: '',
  secondaryColor: '',
  loginHeadline: '',
  loginSubhead: '',
  supportEmail: '',
  supportUrl: '',
  emailFromName: '',
  hidePoweredBy: false,
  platformBillsPartner: true,
  defaultRetailCollector: 'partner',
  retailCollector: '',
  includeInPartnerWholesale: true,
};

export function brandFromTenant(tenant) {
  return {
    appName: tenant?.brand?.appName || '',
    logoUrl: tenant?.brand?.logoUrl || '',
    logoMarkUrl: tenant?.brand?.logoMarkUrl || '',
    faviconUrl: tenant?.brand?.faviconUrl || '',
    primaryColor: tenant?.brand?.primaryColor || '',
    secondaryColor: tenant?.brand?.secondaryColor || '',
    loginHeadline: tenant?.brand?.loginHeadline || '',
    loginSubhead: tenant?.brand?.loginSubhead || '',
    supportEmail: tenant?.brand?.supportEmail || '',
    supportUrl: tenant?.brand?.supportUrl || '',
    emailFromName: tenant?.brand?.emailFromName || '',
    hidePoweredBy: Boolean(tenant?.brand?.hidePoweredBy),
  };
}

export function brandToPayload(formData) {
  return {
    appName: formData.appName || null,
    logoUrl: formData.logoUrl || null,
    logoMarkUrl: formData.logoMarkUrl || null,
    faviconUrl: formData.faviconUrl || null,
    primaryColor: formData.primaryColor || null,
    secondaryColor: formData.secondaryColor || null,
    loginHeadline: formData.loginHeadline || null,
    loginSubhead: formData.loginSubhead || null,
    supportEmail: formData.supportEmail || null,
    supportUrl: formData.supportUrl || null,
    emailFromName: formData.emailFromName || null,
    hidePoweredBy: Boolean(formData.hidePoweredBy),
  };
}

export function tenantToForm(tenant) {
  return {
    ...emptyTenantForm,
    name: tenant.name || '',
    domain: tenant.domain || '',
    subdomain: tenant.subdomain || '',
    kind: tenant.kind === 'partner' ? 'partner' : 'customer',
    partnerId: tenant.partnerId || '',
    ...brandFromTenant(tenant),
    platformBillsPartner: tenant.billing?.platformBillsPartner !== false,
    defaultRetailCollector: tenant.billing?.defaultRetailCollector || 'partner',
    retailCollector: tenant.billing?.retailCollector || '',
    includeInPartnerWholesale: tenant.billing?.includeInPartnerWholesale !== false,
  };
}

export function formToTenantPayload(formData, { includeSubdomain = false } = {}) {
  const payload = {
    name: formData.name,
    domain: formData.domain || null,
    kind: formData.kind,
    partnerId: formData.kind === 'customer' && formData.partnerId ? formData.partnerId : null,
    brand: brandToPayload(formData),
    billing: formData.kind === 'partner'
      ? {
          platformBillsPartner: Boolean(formData.platformBillsPartner),
          defaultRetailCollector: formData.defaultRetailCollector || 'partner',
        }
      : {
          retailCollector: formData.retailCollector || null,
          includeInPartnerWholesale: Boolean(formData.includeInPartnerWholesale),
        },
  };
  if (includeSubdomain && formData.subdomain) {
    payload.subdomain = formData.subdomain;
  }
  return payload;
}
